export default "__VITE_ASSET__DQaf6eSn__"